import win from 'global/window';
import { isString } from './utils';

var isLocation = function isLocation(origin) {
  return (origin == null ? void 0 : origin.protocol) && (origin == null ? void 0 : origin.hostname);
};

var determineOrigin = function determineOrigin(origin) {
  var actualOrigin = origin !== null && origin !== void 0 ? origin : win == null ? void 0 : win.location;

  if (isLocation(actualOrigin)) {
    var protocol = actualOrigin.protocol,
        hostname = actualOrigin.hostname,
        port = actualOrigin.port;
    return protocol + "//" + hostname + (port ? ":" + port : '');
  }

  if (isString(actualOrigin)) {
    return actualOrigin;
  }

  return '';
};

export default determineOrigin;
//# sourceMappingURL=determine-origin.js.map